import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const processed = useRef(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) { navigate("/auth?mode=login"); return; }
        const sessionId = match[1];
        (async () => {
            try {
                const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
                setUser(data);
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/dashboard");
            } catch {
                setError(true);
                setTimeout(() => navigate("/auth?mode=login"), 1500);
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4">
            <div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin" />
            <p className="text-muted-foreground">{error ? "Autenticazione fallita, reindirizzamento…" : "Accesso in corso…"}</p>
        </div>
    );
}
